import { RadioField, useDirtyState } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { isRestrictedFeatureSelector } from 'features/billing';
const formWrapperCss = "fu16k2h";
const FormWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(formWrapperCss, props.className)} />;
});
export const FormContent = ({
  children
}) => {
  const upgradeIsRequired = useSelector(state => isRestrictedFeatureSelector(state, {
    featureKey: 'contact_enrichment'
  }));
  const disabledByPayWall = upgradeIsRequired;
  const formChanged = useDirtyState();
  return <FormWrapper>
      <div>
        <RadioField label={<BodyText>{I18n.t('publisher.account_settings.contact_enrichment.option.enabled')}</BodyText>} disabled={disabledByPayWall} name="enrichmentEnabled" value="enabled" />
        <RadioField label={<BodyText>{I18n.t('publisher.account_settings.contact_enrichment.option.disabled')}</BodyText>} disabled={disabledByPayWall} name="enrichmentEnabled" value="disabled" />
      </div>
      {children && children({
      formChanged,
      disabledByPayWall
    })}
    </FormWrapper>;
};

require("./form_content.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./form_content.js");